// src/redux/sagas/makeReservationSaga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import type { MakeReservationRequest } from '../../types/tableReservation';
import {
  makeReservationRequest,
  makeReservationSuccess,
  makeReservationFailure,
} from '../slices/makeReservationSlice';
import { fetchTableAvailabilityRequest } from '../slices/tableAvailabilitySlice';

function* makeReservationSaga(
  action: PayloadAction<MakeReservationRequest>
): Generator<unknown, void, AxiosResponse<any>> {
  try {
    const response = yield call(request<any>, {
      method: 'POST',
      url: ENDPOINTS.MAKE_RESERVATION,
      data: action.payload,
      requiresRestaurantId: true,
    });

    yield put(makeReservationSuccess(JSON.stringify(response.data)));
    
    // Auto-refresh table availability for the reserved date
    const date = action.payload.reservation_start_time.split(' ')[0];
    yield put(fetchTableAvailabilityRequest({ date }));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to make reservation';
    yield put(makeReservationFailure(errorMessage));
  }
}

export function* watchMakeReservationSaga() {
  yield takeEvery(makeReservationRequest.type, makeReservationSaga);
}
